class PLPColorsInventory {
  constructor(container) {
    this.container = container;
    this.swatches = this.container.querySelectorAll('[data-product-gid]');
    this.skeletons = this.container.querySelectorAll('[data-plp-skeleton-colors]');
    this.colorsWrappers = this.container.querySelectorAll('[data-plp-colors-wrapper]');

    this.init();
  }

  init() {
    const gidsSet = new Set();
    this.swatches.forEach((swatch) => {
      const gid = swatch.getAttribute('data-product-gid');
      if (gid) gidsSet.add(gid);
    });

    const gids = Array.from(gidsSet);

    if (gids.length === 0) {
      this.reveal();
      return;
    }

    const origin = window.location.origin;

    let STOREFRONT_ACCESS_TOKEN;
    let GRAPHQL_URL;

    if (origin.includes('dev.amaro.pro')) {
      STOREFRONT_ACCESS_TOKEN = DEV_STOREFRONT_ACCESS_TOKEN;
      GRAPHQL_URL = DEV_GRAPHQL_URL;
    } else {
      STOREFRONT_ACCESS_TOKEN = PROD_STOREFRONT_ACCESS_TOKEN;
      GRAPHQL_URL = PROD_GRAPHQL_URL;
    }

    const ids = gids.map((gid) => `"${gid}"`).join(',');

    const query = `query { 
      nodes(ids: [${ids}]) { 
        ... on Product { 
          id 
          availableForSale 
          totalInventory 
          onlineStoreUrl 
          colorPicker: metafield(namespace: "colors", key: "color_picker") {
            value
          }
        } 
      } 
    }`;

    const GRAPHQL_BODY = {
      async: "true",
      method: "POST",
      headers: {
        "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN,
        "Content-Type": "application/graphql",
      },
      body: query,
    };

    fetch(GRAPHQL_URL, GRAPHQL_BODY)
      .then(response => response.json())
      .then(({ data }) => {
    const validGids = new Set();

    data.nodes.forEach(node => {
        if (!node || !node.colorPicker) return;

        try {
            const pickerData = JSON.parse(node.colorPicker.value);
            const pickerIds = pickerData.colorPickers.map(cp => cp.productId);

            if (node.availableForSale && node.totalInventory > 0 && node.onlineStoreUrl) {
                if (pickerIds.includes(node.id)) {
                    validGids.add(node.id);
                }
            }
        } catch (e) {
            console.error("Erro ao processar metafield JSON:", e);
        }
    });

    this.swatches.forEach(swatch => {
        const gid = swatch.getAttribute('data-product-gid');
        swatch.style.display = validGids.has(gid) ? 'flex' : 'none';
    });
})
      .finally(() => {
        this.reveal();
      });
  }

  reveal() {
    this.skeletons.forEach(skeleton => {
      skeleton.style.display = 'none';
    });
    this.colorsWrappers.forEach(wrapper => {
      wrapper.style.display = 'block';
    });

    if (window.innerWidth <= 767) {
      this._reserveSwatchSpace();
    }
  }

  _reserveSwatchSpace() {
    document.querySelectorAll('[data-product-block]').forEach(card => {
      const hasCustomSwatches = !!card.querySelector('[data-plp-colors-wrapper]');
      const hasVariantSwatches = !!card.querySelector('product-grid-item-swatch');

      if (hasCustomSwatches || hasVariantSwatches) return;

      const info = card.querySelector('.product-grid-item__info');
      if (!info || info.querySelector('[data-swatch-spacer]')) return;

      const title = info.querySelector('.product-grid-item__title');
      if (!title) return;

      const spacer = document.createElement('div');
      spacer.setAttribute('data-swatch-spacer', '');
      spacer.setAttribute('aria-hidden', 'true');
      spacer.style.height = '30px';
      title.insertAdjacentElement('afterend', spacer);
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  new PLPColorsInventory(document);
});

// Re-init after Ajax grid re-render (filter/sort). rAF defers past the
// innerHTML grid replace; re-hiding an already-hidden skeleton is idempotent.
document.addEventListener('theme:filters:init', function () {
  requestAnimationFrame(function () {
    new PLPColorsInventory(document);
  });
});
